/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import Close from '../../component/button/Close';
import Primary from '../../component/button/Primary';
import {
  StyledBox,
  StyledButtons,
  StyledClose,
  StyledLeftButton,
  StyledMessage,
  StyledMessageBox,
  StyledRightButton,
} from './style';

export const Message = ({ message = null }) => (
  <StyledMessage className={'Permission-StyledMessage'}>
    {message}
  </StyledMessage>
);

export const CloseButton = ({ onCloseClick = null }) => {
  const onClick = useCallback(
    event => {
      event.preventDefault();
      if (typeof onCloseClick === 'function') {
        onCloseClick.call(this);
      }
    },
    [onCloseClick]
  );

  return (
    <StyledClose>
      <Close onClick={onClick} color="red" />
    </StyledClose>
  );
};

// ---
export const Button = ({ primary = false, action = null, label = null }) => {
  const onClick = useCallback(
    event => {
      event.preventDefault();
      if (typeof action === 'function') {
        action.call(this);
      }
    },
    [action]
  );

  return (
    <Primary primary={primary} onClick={onClick}>
      {label}
    </Primary>
  );
};

export const Buttons = props => (
  <StyledButtons>
    <StyledLeftButton>
      {
        // cancel
      }
      <Button
        primary={false}
        label={props.closeLabel}
        action={props.onCancelClick}
      />
    </StyledLeftButton>
    <StyledRightButton>
      {
        // activate
      }
      <Button primary label={props.actionLabel} action={props.onActionClick} />
    </StyledRightButton>
  </StyledButtons>
);
// ---

/**
 * survey 開始前: 許可を得るための yes / no container を作成します
 * @param {string} [className=''] optional class name
 * @param {*} props React.props
 * - message {string} - container title
 * - onCloseClick {function} - close click callback
 * - onCancelClick {function} - No click callback
 * - onActionClick {function} - Yes click callback
 * - closeLabel {string} - No button text
 * - actionLabel {string} - Yes button text
 * @return {*} React.node - yes / no container を返します
 * @constructor
 */
const Permission = ({ className = '', ...props }) => {
  return (
    <StyledBox className={`Permission ${className}`}>
      <StyledMessageBox>
        <Message {...props} />
        <CloseButton {...props} />
      </StyledMessageBox>
      <Buttons {...props} />
    </StyledBox>
  );
};

// Permission.propTypes = {
//   message: PropTypes.string.isRequired,
//   onActionClick: PropTypes.func,
//   onCancelClick: PropTypes.func,
//   onCloseClick: PropTypes.func,
//   actionLabel: PropTypes.string.isRequired,
//   closeLabel: PropTypes.string.isRequired,
// };
//
// Permission.defaultProps = {
//   onActionClick: null,
//   onCancelClick: null,
//   onCloseClick: null,
// };

export default Permission;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/permission/Permission.js